import { Tab } from '@mui/material';
import GeneralTab from '../../../../Components/GeneralTabAndTabContent';
import { TabPanel } from '@mui/lab';
import FvpGeneralSetting from './GeneralSetting';
import VideoSectionsSplitConfig from './videoSectionSplitConfig';
import FallBackXmlConfig from './FallBackXmlConfig';
import FvpBundleScriptSplit from './FvpBundleScriptSplit';
import { ACCESS_CONTROL_CONSTANTS } from '../../../../core/constants';

const { SYSTEMS } = ACCESS_CONTROL_CONSTANTS;

const tabListAndPanels = [
	{
		tab: (
			<Tab label="General Settings" value="FVP_SITE_CONFIG.GENERAL" key="FVP_SITE_CONFIG.GENERAL" />
		),
		tabPanel: (
			<TabPanel
				value="FVP_SITE_CONFIG.GENERAL"
				key="FVP_SITE_CONFIG.GENERAL"
				sx={{ padding: 0, marginTop: '1.5rem' }}
			>
				<FvpGeneralSetting />
			</TabPanel>
		)
	},
	{
		tab: (
			<Tab
				label="Split Config Settings"
				value="FVP_SITE_CONFIG.SPLIT_CONFIG_SETTING"
				key="FVP_SITE_CONFIG.SPLIT_CONFIG_SETTING"
			/>
		),
		tabPanel: (
			<TabPanel
				value="FVP_SITE_CONFIG.SPLIT_CONFIG_SETTING"
				key="FVP_SITE_CONFIG.SPLIT_CONFIG_SETTING"
				sx={{ padding: 0, marginTop: '1.5rem' }}
			>
				<VideoSectionsSplitConfig keyData={'sectionLevelSplit'} />
			</TabPanel>
		)
	},
	{
		tab: (
			<Tab
				label="Fvp Bundle Script Split"
				value="FVP_SITE_CONFIG.FVP_BUNDLE_SCRIPT_SPLIT"
				key="FVP_SITE_CONFIG.FVP_BUNDLE_SCRIPT_SPLIT"
			/>
		),
		tabPanel: (
			<TabPanel
				value="FVP_SITE_CONFIG.FVP_BUNDLE_SCRIPT_SPLIT"
				key="FVP_SITE_CONFIG.FVP_BUNDLE_SCRIPT_SPLIT"
				sx={{ padding: 0, marginTop: '1.5rem' }}
			>
				<FvpBundleScriptSplit keyData={'fvpBundleScriptSplit'} />
			</TabPanel>
		)
	},
	{
		tab: (
			<Tab
				label="Fallback Xml Config"
				value="FVP_SITE_CONFIG.FALLBACK_XML_CONFIG"
				key="FVP_SITE_CONFIG.FALLBACK_XML_CONFIG "
			/>
		),
		tabPanel: (
			<TabPanel
				value="FVP_SITE_CONFIG.FALLBACK_XML_CONFIG"
				key="FVP_SITE_CONFIG.FALLBACK_XML_CONFIG"
				sx={{ padding: 0, marginTop: '1.5rem' }}
			>
				<FallBackXmlConfig keyData={'fallbackXmlConfig'} />
			</TabPanel>
		)
	}
];

const SiteConfig = () => {
	return (
		<GeneralTab
			tabListAndPanels={tabListAndPanels}
			tabListStyles={{ width: 'fit-content', marginLeft: '3rem' }}
			system={SYSTEMS.FVP_PLAYER}
			tabListProps={{
				variant: 'scrollable',
				visibleScrollbar: true,
				scrollButtons: 'auto',
				sx: {
					'& .MuiTabs-scrollableX': {
						'&::-webkit-scrollbar': {
							height: '10px'
						}
					}
				}
			}}
		/>
	);
};

export default SiteConfig;
